
import { useResize } from '@/hooks/useResize';

export const useIsMobile = () => {
  const windowRect = useResize();
  const { width } = windowRect;
  return width < 960;
};

export default useIsMobile;
